// 合同审批待办列表
const ApplyList = resolve => require(['@/views/ContractApply/ApplyTodoList'], resolve)
// 合同特殊评审流程汇总
const ContractDetail = resolve => require(['@/views/ContractApply/ContractDetail'], resolve)
// 合同非标准商务条款申请
const SpecialProvisionsApproval = resolve => require(['@/views/ContractApply/SpecialProvisionsApproval'], resolve)
// 合同非标准商务条款申请明细列表
const SpecialProvisionsDetailApproval = resolve => require(['@/views/ContractApply/SpecialProvisionsDetailApproval'], resolve)
// 新旧价格转换工具
const PriceConvertTool = resolve => require(['@/views/ContractApply/PriceConvertTool'], resolve)
// 单点系统跳转App公用审批页面
const TodoDetail = resolve => require(['@/views/ContractApply/TodoDetail'], resolve)
// 合同审批流程
const TodoListContract = resolve => require(['@/views/Todo_Contract/TodoListContract'], resolve)
// 收付款管理
const Paymentmanage = resolve => require(['@/views/Todo_Contract/Paymentmanage'], resolve)
// 合同变更审批流程
const TodoListContractChange = resolve => require(['@/views/Todo_ContractChange/TodoListContractChange'], resolve)
// 合同变更收付款管理
const ContractChangePaymentmanage = resolve => require(['@/views/Todo_ContractChange/ContractChangePaymentmanage'], resolve)
export default [
  {
    name: 'Apply_List',
    path: '/ContractApply/list',
    component: ApplyList,
    meta: {
      keepAlive: false,
      title: '待办列表',
    },
  },
  {
    name: 'Contract',
    path: '/ContractApply/list/contract',
    component: ContractDetail,
    meta: {
      keepAlive: false,
      title: '合同特殊评审流程汇总',
    },
  },
  {
    name: 'SpecialProvisionsApproval',
    path: '/ContractApply/list/contract/SpecialProvisionsApproval',
    component: SpecialProvisionsApproval,
    meta: {
      keepAlive: false,
      title: '审批详情',
    },
  },
  {
    name: 'SpecialProvisionsDetailApproval',
    path: '/ContractApply/list/contract/SpecialProvisionsApproval/Detail',
    component: SpecialProvisionsDetailApproval,
    meta: {
      keepAlive: false,
      title: '合同非标准商务条款申请明细列表',
    },
  },
  {
    name: 'PriceConvertTool',
    path: '/ContractApply/list/PriceConvertTool',
    component: PriceConvertTool,
    meta: {
      keepAlive: false,
      title: '新旧价格转换工具',
    },
  },
  {
    name: 'TodoDetail',
    path: '/ContractApply/list/TodoDetail',
    component: TodoDetail,
    meta: {
      keepAlive: false,
      title: '审批详情页面',
    },
  },
  {
    name: 'TodoListContract',
    path: '/ContractApply/TodoListContract',
    component: TodoListContract,
    meta: {
      keepAlive: false,
      title: '合同审批流程',
    },
  },
  {
    name: 'Paymentmanage',
    path: '/ContractApply/TodoListContract/Paymentmanage',
    component: Paymentmanage,
    meta: {
      keepAlive: false,
      title: '收付款管理',
    },
  },
  {
    name: 'TodoListContractChange',
    path: '/Views/Todo_ContractChange/TodoListContractChange',
    component: TodoListContractChange,
    meta: {
      keepAlive: false,
      title: '合同变更审批流程',
    },
  },
  {
    name: 'ContractChangePaymentmanage',
    path: '/Views/Todo_ContractChange/ContractChangePaymentmanage',
    component: ContractChangePaymentmanage,
    meta: {
      keepAlive: false,
      title: '合同变更收付款管理',
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/applytodeList.js